export const SET_SUPPLIERS = 'ENTITY/SET_SUPPLIERS';
export const SET_SELECTED_SUPPLIER = 'ENTITY/SET_SELECTED_SUPPLIER';
export const SET_SELECTED_ENTITY = 'ENTITY/SET_SELECTED_ENTITY';
export const SET_LOADING = 'ENTITY/SET_LOADING';
export const SET_ERROR = 'ENTITY/SET_ERROR';
export const CLEAR_ENTITY = 'ENTITY/CLEAR_ENTITY';

const initialState = {
  suppliers: [],
  selectedSupplier: '',
  selectedEntity: '',
  selectedSupplierData: null,
  loading: false,
  error: null,
};

const entityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUPPLIERS:
      const suppliers = action.payload;
      const firstSupplier = suppliers.length > 0 ? suppliers[0] : null;
      const firstEntity = firstSupplier?.entity_info?.length > 0 ? firstSupplier.entity_info[0] : null;
      const selectedSupplierId = state.selectedSupplier || (firstSupplier?.id || '');
      
      return {
        ...state,
        suppliers: suppliers,
        selectedSupplier: selectedSupplierId,
        selectedEntity: state.selectedEntity || (firstEntity?.esi_id || ''),
        selectedSupplierData: suppliers.find(s => s.id === selectedSupplierId) || null,
        loading: false,
        error: null,
      };
    
    case SET_SELECTED_SUPPLIER:
      const selectedSupplierData = state.suppliers.find(s => s.id === action.payload);
      const firstEntityForSupplier = selectedSupplierData?.entity_info?.length > 0 ? selectedSupplierData.entity_info[0] : null;
      
      return {
        ...state,
        selectedSupplier: action.payload,
        selectedSupplierData: selectedSupplierData || null,
        selectedEntity: firstEntityForSupplier?.esi_id || '',
      };

    case SET_SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.payload,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case CLEAR_ENTITY:
      return initialState;

    default:
      return state;
  }
};

export default entityReducer;
